



















import { Component, Vue, Prop } from 'vue-property-decorator';
import MultipleSelectTeam from '@/components/multipleSelectTeam.vue';

type ITeamInfo = ITeam.IResponse.ITeamInfo;

@Component({
  components: {
    MultipleSelectTeam,
  },
})
export default class EditTeams extends Vue {
  @Prop({required: true}) private type!: 'add' | 'del';
  @Prop({default: () => []}) private teams!: ITeamInfo[];
  @Prop({required: true}) private submitAddTeams!: (
    teamIds: string[],
  ) => Promise<string>;
  @Prop({required: true}) private submitDelTeams!: (
    teamIds: string[],
  ) => Promise<string>;
  private mode = 'multiple';
  private loading = false;
  private selectedList: string[] = [];
  private removedList: string[] = [];
  private currentTeams: ITeamInfo[] = [];
  private created() {
    this.resetEdit();
  }
  // 获取当前的TeamIds
  get currentTeamIds() {
    return this.currentTeams.map((team) => team.id);
  }
  // 处理选项改变，添加权限
  private handleChange(value: string[]) {
    if (this.mode === 'multiple') {
      this.selectedList = value;
    }
  }
  // 重置编辑数据
  private resetEdit() {
    this.selectedList = [];
    this.removedList = [];
    this.currentTeams = [...this.teams];
  }
  // 删除开发组
  private removeCurrentTeams(teamId: string) {
    const newcurrentTeams = this.currentTeams.filter((team) => team.id !== teamId);
    this.currentTeams = newcurrentTeams;
    this.removedList.push(teamId);
  }
  private handleAddTeams() {
    if (this.selectedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitAddTeams(this.selectedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
  private handleDelTeams() {
    if (this.removedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitDelTeams(this.removedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
}
